const advanceSign = {
  path: 'advanceSign/:signatureKey',
  props: true,
  component: resolve => require(['../../../pages/enroll/advance/sign'], resolve)
}

export default advanceSign
